import { render, staticRenderFns } from "./AvatarAdult.vue?vue&type=template&id=0591da51&scoped=true&lang=pug"
import script from "./AvatarAdult.vue?vue&type=script&lang=js"
export * from "./AvatarAdult.vue?vue&type=script&lang=js"
import style0 from "./AvatarAdult.vue?vue&type=style&index=0&id=0591da51&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0591da51",
  null
  
)

export default component.exports